/*
  Error constants in the following array will be suppressed (not shown to the user)
*/

import { INVITE_TEAM_MEMBER, UPDATE_TEAM_MEMBER } from 'root/stores/teams';

import { CREATE_BOARD, UPDATE_BOARD } from '../boards';

export default [
  CREATE_BOARD,
  INVITE_TEAM_MEMBER,
  UPDATE_BOARD,
  UPDATE_TEAM_MEMBER,
];
